import React from "react"
import styled from "styled-components"
import devices from "styles/devices"
import { Button } from "components/atoms"

const ToastButton = styled(Button)({
  width: "100%",
  background: "#1a3dd1",
  color: "#fff",
  textAlign: "center",
  boxShadow: "inset 0 -6px 0px #052ea3",

  [`@media screen and ${devices.bp_sm}`]: {
    width: "auto",
  },
})

const CheckSvg = () => (
  <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.9856 6.91546L10.8429 27.1L1.01465 16.7369L3.73559 14.1564L10.8429 21.6505L27.2647 4.33496L29.9856 6.91546Z"
      fill="#038352"
    />
  </svg>
)

const ModalContainer = styled.div({
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
})

const RateRequestedContainer = styled.div({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  maxWidth: "600px",
  backgroundColor: "white",
  borderRadius: "32px",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
  overflow: "hidden",
})

const RateRequestedHeader = styled.div({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "1.5rem 2rem",
  backgroundColor: "#EDF5F3",
  color: "#3B4258",
  fontWeight: 600,
  fontSize: "1.5rem",
})

const CheckIcon = styled.div({
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  marginRight: "12px",
})

const RateRequestedContent = styled.div({
  padding: "2rem",
  gap: "0.5rem",
  display: "flex",
  flexDirection: "column",
})

const RateRequestedNote = styled.div({
  backgroundColor: "#FFF5F5",
  borderRadius: "32px",
  padding: "1.5rem",
  margin: "1rem 0",
})

const ButtonContainer = styled.div({
  display: "flex",
  justifyContent: "center",
  padding: "0 1rem",
})

export const NewRateModal = ({ onClose }) => {
  return (
    <ModalContainer>
      <RateRequestedContainer>
        <RateRequestedHeader>
          <CheckIcon>
            <CheckSvg />
          </CheckIcon>
          Rate Requested
        </RateRequestedHeader>

        <RateRequestedContent>
          <div>Great! Your request will now go to your Mortgage Expert for review.</div>

          <RateRequestedNote>
            <strong>Note:</strong> If you're too close to completion, the lender might not allow us
            to switch you to the new rate
          </RateRequestedNote>

          <ButtonContainer>
            <ToastButton
              onClick={onClose}
              width="auto"
              type={2}
              text="OK"
              style={{
                alignSelf: "center",
              }}
            />
          </ButtonContainer>
        </RateRequestedContent>
      </RateRequestedContainer>
    </ModalContainer>
  )
}
